var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.$style.container},_vm._l((_vm.tabs),function(tab,index){return _c('div',{key:index,class:{ [_vm.$style.hidden]: !tab.shouldShowTab }},[_c('ul',{class:_vm.$style.header},[_c('li',[_c('a',{class:[_vm.$style.headerText, {
            [_vm.$style.activeHeaderText]: _vm.isActiveSelection(index),
          }],attrs:{"data-test-id":"SystemsMainPanelTabs_tab"},on:{"click":function($event){return _vm.handleClick(index)}}},[_vm._v(" "+_vm._s(tab.label)+" ")])])])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }